import { LitElement, html, property } from 'lit-element'
import { register } from '@polleverywhere/hmr-custom-element'
import { bemBlock } from '@polleverywhere/bem-helpers'
import { contextualize, cutlassEvent } from '@polleverywhere/cutlass'
import '@polleverywhere/icon-element'
import './viz-brandbar.scss'

function handleLogoClick (_) {
  if (this.hideUpsells) return

  cutlassEvent(this, 'upsell-clicked')

  this.dispatchEvent(new CustomEvent('upsell-clicked', {
    bubbles: true,
    detail: {}
  }))
}

/**
 * Renders a brandbar element.
 *
 * * When you want to use this component, bring it in to your context with
 * `import @polleverywhere/viz-brandbar`
 *
 * @element viz-brandbar
 *
 * @prop {Boolean} [hide-upsells=false] - enable to remove the click handler on the Poll Everywhere logo
 * @prop {String} [theme=bright] - renders a 'bright', 'classic' or 'dark' theme, changing the text and background colors.
 * @fires upsell-clicked - fires event when the Poll Everywhere upsell icon is clicked
 */
export class BrandBar extends LitElement {
  static tagName = 'viz-brandbar'

  @property({ type: String })
  theme = 'bright'

  @property({ type: Boolean, attribute: 'hide-upsells' })
  hideUpsells = false

  createRenderRoot () { return this }

  constructor () {
    super()
    contextualize(this, this.tagName)
  }

  render () {
    return html`
    <icon-element
        class=${bem('logo')}
        @click='${handleLogoClick.bind(this)}'
        type='svg'
        name='powered-by-logo'
    ></icon-element>`
  }
}

const bem = bemBlock(BrandBar.tagName)
register(module, BrandBar.tagName, BrandBar)
